import * as React from "react";
import {FormProvider, UnpackNestedValue, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import {t} from "../../i18n";
import {useState} from "react";
import {updateUserDetails} from "../UserActions";



export const ProfileReceivePromoForm = () => {
    const defValue = useSelector((app : AppState) => app.user.user?.attributes?.["receivePromoCommunication"]);
    const [checked, setChecked] = useState(defValue == "true");
    const dispatch = useDispatch();

    const save = () => {
        let update = !checked;
        setChecked(update);
        dispatch(updateUserDetails({receivePromoCommunication : update ? "true" : "false"}) as any);
    }

    let name = "receivePromoCommunication";
    return (
        <div className={"row account-page-row compact"}>
            <div className={"col-md-6"}>
                <label>{t("forms.attributes.receivePromoCommunication.title")}:</label>
                <span className={"help"}>{t("forms.attributes.receivePromoCommunication.label")}</span>
            </div>
            <div className={"col-md-6 right"}>
                <div className={"switch"}>
                    <input type="checkbox"
                           checked={checked}
                           id={name} className={"switch__input"}
                    />
                    <label htmlFor={"name"} className={"switch__label"}   onClick={() => save()}>
                    </label>
                </div>
            </div>
        </div>

    )
}